import React from 'react';

import HotelCardPrice from '../HotelCardPrice/HotelCardPrice';
import HotelCardExploreButton from '../HotelCardExploreButton';

import type { HotelCardPriceBlockProps as Props } from './types';
import styles from './hotelCardPriceBlock.module.css';

const HotelCardPriceBlock = ({
  instantConfirm,
  isFlexDates,
  isMapCard,
  price,
  currencyCode,
  availability,
  isHotelOnly,
  hotelPageHref,
  isCardHovered,
  isExpanded,
  openInCurrentTab,
  datesInfo = '',
}: Props) => (
  <div className={styles.priceBlock}>
    <HotelCardPrice
      price={price}
      currencyCode={currencyCode}
      availability={availability}
      isHotelOnly={isHotelOnly}
      instantConfirm={instantConfirm}
      isMobile={false}
      isFlexDates={isFlexDates}
      isMapCard={isMapCard}
      datesInfo={datesInfo}
    />
    {(!isMapCard || isExpanded) && (
      <HotelCardExploreButton
        href={hotelPageHref}
        isCardHovered={isCardHovered}
        openInCurrentTab={openInCurrentTab}
        isHotelOnly={isHotelOnly}
      />
    )}
  </div>
);

export default HotelCardPriceBlock;
